import { render, staticRenderFns } from "./Unsended.vue?vue&type=template&id=a1254454"
import script from "./Unsended.vue?vue&type=script&lang=js"
export * from "./Unsended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports